import { render } from "./graph-history-injection.vue?vue&type=template&id=3b8966b1&scoped=true"
import script from "./graph-history-injection.vue?vue&type=script&lang=js"
export * from "./graph-history-injection.vue?vue&type=script&lang=js"

import "./graph-history-injection.vue?vue&type=style&index=0&id=3b8966b1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8966b1"]])

export default __exports__